import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function presClubReducer(state = InitialState.presClubAdminDetails, action) {

  switch (action.type) {
    case types.LOAD_PRES_CLUB_REVENUE_SUCCESS:
      return {
        ...state,
        revDetails: action.revDetails
      };
    case types.LOAD_PRES_CLUB_UTILIZATION_SUCCESS:
        return {
            ...state,
            utilDetails: action.utilDetails
        };
    case types.LOAD_PRES_CLUB_REVENUE_ADMIN_SUCCESS:
      return {
        ...state,
        revAdminDetails: action.revDetails
      }
    case types.LOAD_PRES_CLUB_UTILIZATION_ADMIN_SUCCESS:
      return {
        ...state,
        utilAdminDetails: action.utilDetails
      }
    default:
      return state;
  }
}